import { render, staticRenderFns } from "./MyCurrencyInput.vue?vue&type=template&id=425fa7ae&"
import script from "./MyCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./MyCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports